#import "../../../../shared/graphql/fragments/lead-value-fragment.graphql"
#import "../../../../sidebar/accounts-and-contacts-widget/graphql/fragments/accounts-for-lead-fragment.graphql"
#import "../../../../sidebar/accounts-and-contacts-widget/graphql/fragments/contacts-for-lead-fragment.graphql"
#import "../../../../sidebar/revenue-widget/graphql/fragments/products-for-lead-fragment.graphql"

query LeadBackboneUpdate($id: ID!) {
    lead(id: $id) {
        id
        ...LeadValueFragment
        ...AccountsForLeadFragment
        ...ContactsForLeadFragment
        ...ProductsForLeadFragment
    }
}
